import { ProductJsonLd } from 'next-seo';
import Head from 'next/head';
import { images as allImages } from '../../Constants/ImageUrls';

import { inStockSchema, outOfStockSchema } from '../../Constants/PdpContants';
import { BrandName } from '../../Constants/ProductPage';
import { getStructuredData } from './common';

export default function CategoryHead(props) {
  let { categoryDataInfo, tabsData, categoryId, experimentPage } = props;
  const itemsListArray = tabsData?.[0]?.items
    ?.slice(0, 6)
    ?.map((data, index) => {
      let itemsData = getStructuredData(data, index, categoryId);
      return JSON.stringify(itemsData);
    });
  const firstItem = tabsData?.[0]?.items[0];
  const { nickname, status, _id, image, reviewData, reviews } = firstItem;
  const review_count = firstItem.starRatingSubScript.slice(
    1,
    firstItem.starRatingSubScript.length - 2,
  );
  const aggregateRating = {
    ratingValue: firstItem.avg_rating,
    reviewCount: review_count,
  };
  let price = firstItem?.price;
  if (price.toString().includes('₹')) price = price?.split('₹').pop();
  return (
    <>
      {experimentPage ? (
        <ProductJsonLd
          productName={nickname}
          images={image}
          description={nickname}
          brand={BrandName}
          manufacturerName={BrandName}
          manufacturerLogo={allImages.logo}
          reviews={reviewData || reviews}
          offers={{
            price: price,
            priceCurrency: 'INR',
            availability: status == '4' ? outOfStockSchema : inStockSchema,
          }}
          aggregateRating={aggregateRating}
          sku={_id}
        />
      ) : null}
      <Head>
        <link
          key="canonical"
          rel="canonical"
          href={`https://mylofamily.com${categoryDataInfo}`}
        />
        {!experimentPage
          ? itemsListArray?.length > 0 && (
              <>
                <script
                  type="application/ld+json"
                  nonce=""
                  id="jsonLD"
                  dangerouslySetInnerHTML={{
                    __html: `{"@context":"http://schema.org","@type":"ItemList","itemListElement":[${itemsListArray}]
                    }`,
                  }}
                ></script>
              </>
            )
          : null}
        <meta name="google" content="notranslate" />
      </Head>
    </>
  );
}
